// Copyright (c) 2022 by Move Closer

import { ValidationRules } from '../../../shared/molecules/Form'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const addReviewModalValidationMap: ValidationRules = {
  firstname: 'required|string|min:3',
  comment: 'filled|string|min:3',
  rate: 'required|numeric|min:1|max:5'
}
